export default __webpack_public_path__ + "static/char-s-32-en-99453b3009ba540b39add8ad9e956e1f.webp";